<form>
    <app-form-section [formGroup]="noteReminderForm">
        <ng-container *ngIf="!disabled">
            <app-form-row>
                <app-form-group>
                    <!-- <label for="note">{{ 'FEATURES.AGREEMENTS.NOTE' | translate }}</label> -->
                    <textarea
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        formControlName="note"
                        [placeholder]="'FEATURES.AGREEMENTS.NOTE' | translate"
                    ></textarea>
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <div class="help-label">
                        <app-checkbox
                            formControlName="reminder"
                            [text]="'FEATURES.AGREEMENTS.NOTE_REMINDER' | translate"
                            (change)="toggleReminder()"
                        />
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.NOTE_REMINDER' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </div>
                </app-form-group>
            </app-form-row>
            <div *ngIf="showReminder">
                <app-form-section [formGroup]="noteReminderForm">
                    <app-form-row>
                        <app-form-group>
                            <label for="subject">{{ 'FEATURES.REMINDERS.SUBJECT' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="subject"
                                formControlName="subject"
                                type="text"
                                [placeholder]="'FEATURES.REMINDERS.SUBJECT' | translate"
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages"
                                [control]="f.subject"
                                languageKey="FEATURES.REMINDERS.SUBJECT"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="to">{{ 'FEATURES.REMINDERS.TO' | translate }}</label>
                            <app-multi-select
                                [showToggleAll]="false"
                                [searchable]="true"
                                [showAllText]="false"
                                [items]="users$ | async"
                                formControlName="to"
                                [placeholder]="
                                    'SELECT.SELECT_WITH_LABEL'
                                        | translate
                                            : {
                                                  label: 'FEATURES.REMINDERS.TO' | translate
                                              }
                                "
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages"
                                [control]="f.to"
                                languageKey="FEATURES.REMINDERS.TO"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="reminderDate">{{ 'FEATURES.REMINDERS.REMINDER_DATE' | translate }}</label>
                            <app-date-picker
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                formControlName="reminderDate"
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages"
                                [control]="f.reminderDate"
                                languageKey="FEATURES.REMINDERS.REMINDER_DATE"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="reminderTime">{{ 'FEATURES.REMINDERS.REMINDER_TIME' | translate }}</label>
                            <app-hour-picker
                                appInputValidator
                                id="reminderTime"
                                formControlName="reminderTime"
                            ></app-hour-picker>
                        </app-form-group>
                    </app-form-row>
                </app-form-section>
            </div>
            <app-form-row>
                <app-form-group>
                    <button class="primary green" (click)="addNoteReminder()" [disabled]="isDisabled()">
                        {{ 'FEATURES.REMINDERS.ADD_NOTE' | translate }}
                    </button>
                </app-form-group>
            </app-form-row>
        </ng-container>
        <app-form-row *ngFor="let item of reminders">
            <app-form-group>
                <div class="reminderitem">
                    <div class="reminderitemLeft">
                        <div class="header">
                            <div>
                                <span class="author">{{ item.createdBy }}</span>
                                <span class="time">
                                    {{ item.created | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}
                                </span>
                            </div>
                            <button
                                (click)="deleteNote(item)"
                                class="icon"
                                *appHasPermissions="[permissions.WriteAgreement]"
                            >
                                <span class="material-symbols-rounded" aria-label="delete">delete</span>
                            </button>
                        </div>
                        <div class="section">
                            <h4 *ngIf="item.subject">{{ item.subject }}</h4>
                            {{ item.note }}
                        </div>
                        <div *ngIf="item.reminder">
                            <div class="section" *ngIf="item.id">
                                <h4>{{ 'FEATURES.REMINDERS.NOTIFY' | translate }}</h4>
                                {{ item.to }}
                            </div>
                            <div class="section">
                                <h4>{{ 'FEATURES.REMINDERS.REMINDER_DATE' | translate }}</h4>
                                {{ utcIsoToLocalDate(item.reminderDate) }},
                                {{ utcIsoToLocalTime(item.reminderDate) }}
                            </div>
                        </div>
                    </div>
                    <div class="reminderitemRight" *appHasPermissions="[permissions.WriteAgreement]"></div>
                </div>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>
